import {
  CellState,
  CellType,
  ClueType,
  FeedFormat,
  ICell,
  IClue,
  IPuzzleData,
  PuzzleType,
} from 'js/crossword/types';
import { replaceAll } from 'framework/utils/misc-utils';

interface ITCARawData {
  metaData: {
    author: string;
    title: string;
    description: string;
    date: string;
    feedSlug: string;
    format: FeedFormat;
    id: string;
  };
  data: {
    gridRow: number;
    gridCol: number;
    sourceFile: string;
    clues: ITCAClue[];
    gCells: ITCACell[];
  };  
}

enum TCAClueType {
  ACROSS = "across",
  DOWN = "down",
}

interface ITCAClue {
  answer: string;
  clueNo: number;
  clueType: TCAClueType;
  shape: {
    type: string;
    value: string;
  };
  text: string;
}

enum TCACellType {
  CIRCLE = "circle",
  DISABLE = "disable",
  SQUARE = "square",
}

interface ITCACell {
  id: number;
  cellType: TCACellType;
  cellChar: string;
}

export default function convertTCA(rawData: ITCARawData): IPuzzleData {
  const crossWordData = rawData.data;
  const metaData = rawData.metaData;

  const columns = Number(crossWordData.gridCol);
  const rows = Number(crossWordData.gridRow);

  const clues: IClue[] = crossWordData.clues.map((clueRaw, index) => {
    const cellsIds = clueRaw.shape.value.split(',');

    return {
      id: index.toString(),
      number: Number(clueRaw.clueNo),
      type: clueRaw.clueType === TCAClueType.ACROSS ? ClueType.Across : ClueType.Down,
      text: cleanUpClueText(clueRaw.text),
      cells: cellsIds,
    };
  });

  const cells: ICell[] = crossWordData.gCells.map((cellRaw, index) => {
    const clueForNumber = clues.find((clue) => clue.cells[0] === cellRaw.id.toString());

    return {
      id: cellRaw.id.toString(),
      type: cellRaw.cellType === TCACellType.DISABLE ? CellType.Empty : CellType.Regular,
      letter: '',
      state: CellState.Normal,
      circle: cellRaw.cellType === TCACellType.CIRCLE,
      number: clueForNumber ? clueForNumber.number : null,
      x: index % columns,
      y: Math.floor(index / columns),
      solution: cellRaw.cellChar,
    };
  });

  return {
    type: PuzzleType.Regular,
    id: metaData.id || crossWordData.sourceFile,
    metaData: {
      title: metaData.title || 'Crossword',
      author: metaData.author,
      date: metaData.date,
      format: metaData.format,
    },
    columns,
    rows,
    clues,
    cells,
  };
}

function cleanUpClueText(text: string): string {
  return replaceAll(text, 'É', '');
}
